import ActionTypes from './ActionTypes';
import Node from './Node';
import reducer from './reducer';

export default {
    /**
     * 动作类型
     */
    ActionTypes,

    /**
     * 节点数据
     */
    Node,
    
    reducer
};


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/user/index.ts